import { BrowserRouter, Navigate, Routes, Route } from "react-router-dom";
import ApplyPage from "./pages/Apply/ApplyPage";
import ClinicLogin from "./components/Login/ClinicLogin";
import DashboardLayout from "./components/Dashboard/DashboardLayout";
import ProtectedRoute from "./routes/ProtectedRoute";
import { DashboardPanelProvider } from "./context/DashboardPanelContext";
import PanelSelection from "./pages/Dashboard/PanelSelection";
import Patients from "./pages/Dashboard/Patients";
import PatientsList from "./pages/Dashboard/PatientsList";
import PatientsImport from "./pages/Dashboard/PatientsImport";
import DashboardHome from "./pages/Dashboard/DashboardHome";
import Cases from "./pages/Dashboard/Cases/Cases";
import CaseDetail from "./pages/Dashboard/Cases/CaseDetail";
import CasesImport from "./pages/Dashboard/Cases/CasesImport";
import Reports from "./pages/Dashboard/Reports/Reports";
import Applies from "./pages/Dashboard/Applies/Applies";
import ClinicProfile from "./pages/Dashboard/ClinicProfile/ClinicProfile";
import DoctorProfile from "./pages/Dashboard/DoctorProfile/DoctorProfile";
import Laboratory from "./pages/Dashboard/Laboratory";
import Services from "./pages/Dashboard/Services/Services";
import Payments from "./pages/Dashboard/Payments/Payments";
import Staff from "./components/Dashboard/Staff/Staff";
import EMRs from "./pages/Dashboard/EMRs/EMRs";
import History from "./pages/Dashboard/History/History";
import PublicEmrView from "./pages/Public/PublicEmrView";
import AuditLogs from "./pages/Dashboard/AuditLogs/AuditLogs";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="/apply" element={<ApplyPage />} />
        <Route path="/login" element={<ClinicLogin />} />
        <Route path="/emr/:patientId" element={<PublicEmrView />} />

        {/* PROTECTED DASHBOARD */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <DashboardPanelProvider>
                <DashboardLayout />
              </DashboardPanelProvider>
            </ProtectedRoute>
          }
        >
          <Route path="panel" element={<PanelSelection />} />
          <Route index element={<DashboardHome />} />
          <Route path="patients" element={<Patients />} />
          <Route path="patients-list" element={<PatientsList />} />
          <Route path="patients-import" element={<PatientsImport />} />
          <Route path="cases" element={<Cases />} />
          <Route path="cases-import" element={<CasesImport />} />
          <Route path="cases/:id/:view" element={<CaseDetail />} />
          <Route path="cases/:id" element={<CaseDetail />} />
          <Route path="reports" element={<Reports />} />
          <Route path="applies" element={<Applies />} />
          <Route path="clinic-profile" element={<ClinicProfile />} />
          <Route path="doctor-profile" element={<DoctorProfile />} />
          <Route path="laboratory" element={<Laboratory />} />
          <Route path="services" element={<Services />} />
          <Route path="payments" element={<Payments />} />
          <Route path="staff" element={<Staff />} />
          <Route path="emrs" element={<EMRs />} />
          <Route path="history" element={<History />} />
          <Route path="audit-logs" element={<AuditLogs />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
